module.exports = __webpack_public_path__ + "img/error-face.54a94bdf.svg";